const BASE_URL = "https://axis.coinfo.online/academy-api-rest"
// const BASE_URL = "https://axis.coinfo.online:8443/cs-academy"
const LOCAL_URL = "http://localhost:7000"


export const environment = {
    production: true,

    /**URL Origin Service */
    urlOrigin: BASE_URL,
    localUrl: LOCAL_URL,

    serviceLogin: BASE_URL + '/academy/login',
    serviceLogout: BASE_URL + '/academy/logout',
    serviceRegister: BASE_URL + '/academy/person/register',
    serviceRefreshToken: BASE_URL + '/academy/refresh_token',

    serviceArea: BASE_URL + '/academy/area',

    serviceStudentCourse: BASE_URL + '/academy/student_course',

    serviceCertificate: BASE_URL + '/academy/certificate',

    servicePerson: BASE_URL + '/academy/person',

    serviceInvoice: BASE_URL + '/academy/invoice',

    serviceInvoiceSendHistory: BASE_URL + '/academy/invoice-send-history',

    serviceTrace: BASE_URL + '/academy/traces',

    serviceConfigParameter: BASE_URL + '/academy/parameter',

    serviceApplyCourse: BASE_URL + '/academy/student_course/apply',

    serviceApplyContractCourse: BASE_URL + '/academy/student_course/apply_contract',

    serviceStudentModule: BASE_URL + '/academy/student_module',

    serviceConfigClassImage: BASE_URL + '/academy/config_class_image',

    serviceStudentClass: BASE_URL + '/academy/student_class',

    serviceStudentExam: BASE_URL + '/academy/student_exam',

    serviceImagenes: BASE_URL + '/academy/image',

    serviceConfigExamQuestion: BASE_URL + '/academy/config_exam_question',

    serviceQuestionOption: BASE_URL + '/academy/question-option',

    serviceEmail: BASE_URL + '/academy/email',

    serviceConfigCourse: BASE_URL + '/academy/course',

    serviceConfigCourseInvoice: BASE_URL + '/academy/course-invoice',

    serviceConfigCourseUnitPrice: BASE_URL + '/academy/course-unit-price',

    serviceConfigCourseMixed: BASE_URL + '/academy/course/course-mixed-list',

    serviceConfigCourseFree: BASE_URL + '/academy/course/course-free-list',

    serviceStudentFeedback: BASE_URL + '/academy/student_feedback',

    serviceConfigModule: BASE_URL + '/academy/module',

    serviceConfigClass: BASE_URL + '/academy/class',

    serviceConfigExam: BASE_URL + '/academy/exam',

    serviceConfigReference: BASE_URL + '/academy/reference',

    serviceNomEntity: BASE_URL + '/academy/entity',

    serviceRole: BASE_URL + '/academy/role',

    serviceTemas: BASE_URL + '/academy/temas',

    serviceTitle: BASE_URL + '/academy/title'

};


